import action from '../commons/consultationActionStatus';

export const createConsultationRequestAction = (patientId, appointmentId, hospitalId ) => {
    return {
        type: action.CREATE_CONSULTATION_REQUEST,
        status: 'CREATE_CONSULTATION_REQUEST',
        requestState: true,
        payload: {
            patientId, appointmentId, hospitalId
        }
    };
};

export const createConsultationSuccessAction = (result) => {
    return {
        type: action.CREATE_CONSULTATION_SUCCESS,
        status: 'consulation created sucessfully',
        result,
        requestState: false,
    };
};

export const createConsultationFailureAction = (error) => {
    return {
        type: action.CREATE_CONSULTATION_FAILURE,
        status: 'Consulation creation failure',
        error,
        requestState: false,
    };
};

export const resetConsultationState = () => {
    return {
        type: action.RESET_CONSULTATION_STATE
    };
};

export const updateConsultationRequestAction = (consultationId, body) => {
    return {
        type: action.UPDATE_CONSULTATION_REQUEST,
        status: 'UPDATE_CONSULTATION_REQUEST',
        requestState: true,
        payload: {
            consultationId,
            body
        }
    };
};

export const updateConsultationSuccessAction = (result) => {
    return {
        type: action.UPDATE_CONSULTATION_SUCCESS,
        status: 'consulation updated sucessfully',
        result,
        requestState: false,
    };
};

export const updateConsultationFailureAction = (error) => {
    return {
        type: action.UPDATE_CONSULTATION_FAILURE,
        status: 'Consulation updation failure',
        error,
        requestState: false,
    };
};

export const getTreatmentRequestAction = (consultationId) => {
    return {
        type: action.GET_TREATMENT_REQUEST,
        status: 'GET_TREATMENT_REQUEST',
        requestState: true,
        payload: {
            consultationId,
        }
    };
};

export const getTreatmentSuccessAction = (result) => {
    return {
        type: action.GET_TREATMENT_SUCCESS,
        status: 'Get Treatment sucessfully',
        result,
        requestState: false,
    };
};

export const getTreatmentFailureAction = (error) => {
    return {
        type: action.GET_TREATMENT_FAILURE,
        status: 'Get Treatment failure',
        error,
        requestState: false,
    };
};

export const createUpdateTreatmentRequestAction = (consultationId,body) => {
    return {
        type: action.CREATE_UPDATE_TREATMENT_REQUEST,
        status: 'CREATE_CONSULTATION_REQUEST',
        requestState: true,
        payload: {
            consultationId,
            body
        }
    };
};

export const createUpdateTreatmentSuccessAction = (result) => {
    return {
        type: action.CREATE_UPDATE_TREATMENT_SUCCESS,
        status: 'consulation updated sucessfully',
        result,
        requestState: false,
    };
};

export const createUpdateTreatmentFailureAction = (error) => {
    return {
        type: action.CREATE_UPDATE_TREATMENT_FAILURE,
        status: 'Treatment updation failure',
        error,
        requestState: false,
    };
};

export const resetTreatmentCreation = () => {
    return {
        type: action.RESET_TREATMENT_CREATION_STATE
    };
};

export const endConsultationRequestAction = (consultationId) => {
    return {
        type: action.END_CONSULTATION_REQUEST,
        status: 'END_CONSULTATION_REQUEST',
        requestState: true,
        payload: {
            consultationId,
        }
    };
};

export const endConsultationSuccessAction = (result) => {
    return {
        type: action.END_CONSULTATION_SUCCESS,
        status: 'consulation end sucessfully',
        result,
        requestState: false,
    };
};

export const endConsultationFailureAction = (error) => {
    return {
        type: action.END_CONSULTATION_FAILURE,
        status: 'Consulation end failure',
        error,
        requestState: false,
    };
};

export const updatePhysicalDataRequestAction = (consultationId, body) => {
    return {
        type: action.UPDATE_PHYSICAL_DATA_REQUEST,
        status: 'UPDATE_PHYSICAL_DATA_REQUEST',
        requestState: true,
        payload: {
            consultationId,    
            body
        }
    };
};

export const updatePhysicalDataSuccessAction = (result) => {
    return {
        type: action.UPDATE_PHYSICAL_DATA_SUCCESS,
        status: 'update physical data sucessfully',
        result,
        requestState: false,
    };
};

export const updatePhysicalDataFailureAction = (error) => {
    return {
        type: action.UPDATE_PHYSICAL_DATA_FAILURE,
        status: 'Update Physical data failure',
        error,
        requestState: false,
    };
};